export default __webpack_public_path__ + "static/media/sample.b9dc4007.png";